import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  // Contact form removed as requested

  return (
    <div className="contact-us-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Contact <span>Us</span></h1>
              <p className="lead">
                Get in touch with us for inquiries, quotes, or any questions about our products and services. 
                We're here to help you with all your peanut export needs.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Details Section */}
      <section className="section contact-form-section">
        <div className="container">
          <div className="contact-details-grid">
            <div className="contact-details-main">
              <h2>Contact Details</h2>
              <p>We prefer direct communication. Reach us using the details here.</p>
              <div className="contact-methods">
                <div className="contact-method whatsapp-contact">
                  <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                  </svg>
                  <div>
                    <h4>WhatsApp</h4>
                    <p><a href="https://wa.me/919448165266?text=Hello! I'm interested in your peanut export services. Could you please provide more information?" style={{ color: '#25D366' }} target="_blank" rel="noopener noreferrer">+91 944 816 5266</a></p>
                    <p><a href="https://wa.me/917975855377?text=Hello! I'm interested in your peanut export services. Could you please provide more information?" style={{ color: '#25D366' }} target="_blank" rel="noopener noreferrer">+91 797 585 5377</a></p>
                    <p className="whatsapp-note">Click to start a conversation instantly</p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fa fa-envelope"></i>
                  <div>
                    <h4>Email</h4>
                    <p><a href="mailto:svgadag_12@yahoo.com" style={{ color: '#555' }}>svgadag_12@yahoo.com</a></p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fa fa-phone"></i>
                  <div>
                    <h4>Phone</h4>
                    <p><a href="tel:+919448165266" style={{ color: '#555' }}>+91 944 816 5266</a></p>
                    <p><a href="tel:+917975855377" style={{ color: '#555' }}>+91 797 585 5377</a></p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fa fa-map-marker"></i>
                  <div>
                    <h4>Our Addresses</h4>
                    <div className="addresses-list">
                      <div className="address-item">
                        <i className="fa fa-map-marker-alt"></i>
                        <div className="address-text" style={{ color: '#555' }}>
                          <strong>Head Office:</strong> Gadag - 582101, Karnataka, India
                        </div>
                      </div>
                      <div className="address-item">
                        <i className="fa fa-map-marker-alt"></i>
                        <div className="address-text" style={{ color: '#555' }}>
                          <strong>Gujarat Unit:</strong> Shed No 2A L S No 49/1, Gundala Patri Road, Gundala, Tal, Mundra, Kachchh, Gujarat, 370410, India
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
           
            <div className="contact-details-sidebar" style={{ 'h4': { color: '#f39c12' } }}>
              <h3>Business Hours</h3>
              <div className="contact-item">
                <i className="fa fa-clock"></i>
                <div>
                  <h4 style={{ color: '#f39c12' }}>Working Hours</h4>
                  <p>
                    Mon - Fri: 9:00 AM - 7:00 PM<br />
                    Saturday: 9:00 AM - 5:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section map-section">
        <div className="container">
          <div className="map-section-header">
            <h2>Our Locations</h2>
            <p>Find our offices and processing units across India</p>
          </div>
          
          <div className="maps-grid">
            <div className="map-item">
              <div className="map-header">
                <h3>Head Office - Gadag</h3>
                <p>S. V. Gadag Ginning Factory</p>
              </div>
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3846.077537624847!2d75.6388839!3d15.426365899999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8f945fd23751b%3A0x5e7fba9cf8cd6c97!2sS%20V%20GADAG%20GINNING%20FACTORY!5e0!3m2!1sen!2sin!4v1760970418060!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="S. V. Gadag Ginning Factory Location"
                ></iframe>
              </div>
            </div>
            
            <div className="map-item">
              <div className="map-header">
                <h3>Processing Unit - Gujarat</h3>
                <p>Mundra, Kachchh, Gujarat</p>
              </div>
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3675.0447482781537!2d69.75030137531063!3d22.911720279251647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDU0JzQyLjIiTiA2OcKwNDUnMTAuNCJF!5e0!3m2!1sen!2sin!4v1760970584592!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Gujarat Unit Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Information */}
      <section className="section additional-info">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="info-card">
                <h3>Why Choose Us?</h3>
                <ul>
                  <li>26+ years of experience in peanut exports</li>
                  <li>ISO 22000:2005 and HACCP certified</li>
                  <li>3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House recognition</li>
                  <li>120+ international importers</li>
                  <li>Premium quality products</li>
                  <li>Competitive pricing</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-card">
                <h3>Our Services</h3>
                <ul>
                  <li>Peanut export and processing</li>
                  <li>Quality testing and certification</li>
                  <li>Custom packaging solutions</li>
                  <li>Supply chain management</li>
                  <li>Technical support and consultation</li>
                  <li>After-sales service</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
